// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.freemium.analytics.RentalManagerUserFreemiumAnalyticsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  FreemiumAnalyticsInquiriesResponseWebDto,
  FreemiumAnalyticsOverviewResponseWebDto,
  FreemiumAnalyticsPageViewsResponseWebDto,
  FreemiumAnalyticsPopularAttributesResponseWebDto,
  FreemiumAnalyticsPricingGuidanceResponseWebDto,
  ListingAlias,
  PropertyType,
  RentalManagerFreemiumAnalyticsFilterType,
  UserFreemiumAnalyticsAudienceResponseWebDto,
  UserFreemiumAnalyticsCompsResponseWebDto,
  UserFreemiumAnalyticsPricesResponseWebDto,
} from '../..';

interface AudienceParams {
  bedrooms?: string;
  filterType: RentalManagerFreemiumAnalyticsFilterType;
  listingAlias: ListingAlias;
  propertyType?: PropertyType;
  useTestData?: boolean;
}
interface CompsParams {
  bedrooms?: string;
  filterType: RentalManagerFreemiumAnalyticsFilterType;
  listingAlias: ListingAlias;
  propertyType?: PropertyType;
  useTestData?: boolean;
}
interface InquiriesParams {
  bedrooms?: string;
  filterType: RentalManagerFreemiumAnalyticsFilterType;
  listingAlias: ListingAlias;
  propertyType?: PropertyType;
  useTestData?: boolean;
}
interface OverviewParams {
  beds?: string;
  filterType: RentalManagerFreemiumAnalyticsFilterType;
  listingAlias: ListingAlias;
  propertyType?: PropertyType;
}
interface PageViewsParams {
  bedrooms?: string;
  filterType: RentalManagerFreemiumAnalyticsFilterType;
  listingAlias: ListingAlias;
  propertyType?: PropertyType;
  useTestData?: boolean;
}
interface PopularAttributesParams {
  beds?: number;
  filterType: RentalManagerFreemiumAnalyticsFilterType;
  listingAlias: ListingAlias;
  propertyType?: PropertyType;
  useTestData?: boolean;
}
interface PricesParams {
  bedrooms?: string;
  filterType: RentalManagerFreemiumAnalyticsFilterType;
  listingAlias: ListingAlias;
  propertyType?: PropertyType;
  useTestData?: boolean;
}
interface PricingGuidanceParams {
  listingAlias: ListingAlias;
  useTestData?: boolean;
}

export const RentalManagerUserFreemiumAnalyticsWebApiHandler_audience_Path =
  '/api/web/v1/users/freemium/analytics/audience';

/**
 * Get audience analytics
 */
export const RentalManagerUserFreemiumAnalyticsWebApiHandler_audience = (
  getParams: AudienceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<AudienceParams, never, UserFreemiumAnalyticsAudienceResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserFreemiumAnalyticsWebApiHandler_audience_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserFreemiumAnalyticsWebApiHandler_comps_Path = '/api/web/v1/users/freemium/analytics/comps';

/**
 * Get comps
 */
export const RentalManagerUserFreemiumAnalyticsWebApiHandler_comps = (getParams: CompsParams, client = getClient()) => {
  return httpFrontEndRequest<CompsParams, never, UserFreemiumAnalyticsCompsResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserFreemiumAnalyticsWebApiHandler_comps_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserFreemiumAnalyticsWebApiHandler_inquiries_Path =
  '/api/web/v1/users/freemium/analytics/inquiries';

/**
 * Get inquiries
 */
export const RentalManagerUserFreemiumAnalyticsWebApiHandler_inquiries = (
  getParams: InquiriesParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<InquiriesParams, never, FreemiumAnalyticsInquiriesResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserFreemiumAnalyticsWebApiHandler_inquiries_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserFreemiumAnalyticsWebApiHandler_overview_Path =
  '/api/web/v1/users/freemium/analytics/overview';

/**
 * Get overview
 */
export const RentalManagerUserFreemiumAnalyticsWebApiHandler_overview = (
  getParams: OverviewParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<OverviewParams, never, FreemiumAnalyticsOverviewResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserFreemiumAnalyticsWebApiHandler_overview_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserFreemiumAnalyticsWebApiHandler_pageViews_Path =
  '/api/web/v1/users/freemium/analytics/pageViews';

/**
 * Get page views
 */
export const RentalManagerUserFreemiumAnalyticsWebApiHandler_pageViews = (
  getParams: PageViewsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<PageViewsParams, never, FreemiumAnalyticsPageViewsResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserFreemiumAnalyticsWebApiHandler_pageViews_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserFreemiumAnalyticsWebApiHandler_popularAttributes_Path =
  '/api/web/v1/users/freemium/analytics/popularAttributes';

/**
 * Get popular attributes analytics
 */
export const RentalManagerUserFreemiumAnalyticsWebApiHandler_popularAttributes = (
  getParams: PopularAttributesParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<PopularAttributesParams, never, FreemiumAnalyticsPopularAttributesResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserFreemiumAnalyticsWebApiHandler_popularAttributes_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserFreemiumAnalyticsWebApiHandler_prices_Path =
  '/api/web/v1/users/freemium/analytics/prices';

/**
 * Get price
 */
export const RentalManagerUserFreemiumAnalyticsWebApiHandler_prices = (
  getParams: PricesParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<PricesParams, never, UserFreemiumAnalyticsPricesResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserFreemiumAnalyticsWebApiHandler_prices_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserFreemiumAnalyticsWebApiHandler_pricingGuidance_Path =
  '/api/web/v1/users/freemium/analytics/pricingGuidance';

/**
 * Get pricing guidance
 */
export const RentalManagerUserFreemiumAnalyticsWebApiHandler_pricingGuidance = (
  getParams: PricingGuidanceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<PricingGuidanceParams, never, FreemiumAnalyticsPricingGuidanceResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserFreemiumAnalyticsWebApiHandler_pricingGuidance_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
